<template>
  <v-container fluid>
    <v-row dense>
      <snippet
        v-for="item in items"
        :key="item.etag"
        :data="item.snippet"
        :channel="channel"
      />
    </v-row>
  </v-container>
</template>

<script>
import Snippet from './Snippet.vue'
export default {
  components: { Snippet },
  data(){
    return {
      items: [],
      channel: {}
    }
  },
  mounted(){this.fetch()},
  methods:{
    async fetch(){
      let data = await this.api.get('/youtube/channel')
      if(data){
        this.items = data.search.items
        this.channel = data.channel
      }
    }
  },
}
</script>